import React from 'react';
import useLocale from '@/hooks/useLocale';
import Loader from '@/components/Layout/Loader';
import useAgentsPage from './hooks/useAgentsPage';
import Hero from './components/Hero';
import Features from './components/Features';
import Calendar from './components/Calendar';
import FAQ from './components/FAQ';
import * as Styles from './AgentsPage.styles';

const AgentsPage = () => {
  const { agents: locale } = useLocale();
  const { isLoading } = useAgentsPage();

  if (isLoading) {
    return (
      <Styles.Wrapper>
        <Loader />
      </Styles.Wrapper>
    );
  }

  return (
    <Styles.Wrapper>
      <Styles.Content>
        <Hero locale={locale.hero} />
        <Features locale={locale.features} />
        <Calendar locale={locale.calendar} />
        <FAQ locale={locale.faq} />
      </Styles.Content>
    </Styles.Wrapper>
  );
};

export default AgentsPage;
